// React Hooks
import { useReducer } from "react";

// External Libraries
import { v4 } from "uuid";

// Internal Utilities
import { deepCopy } from "../../../../helper";

// Constants
import { colorCodes } from "../../constant/common";

export const UPDATE_TEMPLATE_TITLE = "UPDATE_TEMPLATE_TITLE";
export const UPDATE_COLOR_CODE = "UPDATE_COLOR_CODE";
export const ADD_DOCUMENT = "ADD_DOCUMENT";
export const UPDATE_DOCUMENT = "UPDATE_DOCUMENT";
export const REMOVE_DOCUMENT = "REMOVE_DOCUMENT";
export const RESET_TEMPLATE_FORM_STATE = "RESET_TEMPLATE_FORM_STATE";
export const SET_TEMPLATE_STATE_FROM_PAYLOAD =
  "SET_TEMPLATE_STATE_FROM_PAYLOAD";
const initialState = {
  templateId: "",
  templateTitle: "",
  colorCode: colorCodes.find((colorCode) => colorCode.label === "Primary") ?? {
    id: 3,
    value: "3",
    label: "Primary",
    colorCode: "#6366F1",
  },
  requiredDocuments: [{ ...getEmptyRequiredDocuments() }],
  initialStateForEdit: {},
};
const templateFormReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_TEMPLATE_TITLE:
      return { ...state, templateTitle: action.payload };
    case UPDATE_COLOR_CODE:
      return { ...state, colorCode: action.payload };
    case ADD_DOCUMENT:
      return {
        ...state,
        requiredDocuments: [...state.requiredDocuments, action.payload],
      };
    case UPDATE_DOCUMENT:
      return {
        ...state,
        requiredDocuments: state.requiredDocuments.map((doc) =>
          doc.documentId === action.payload.documentId
            ? { ...doc, ...action.payload }
            : doc
        ),
      };
    case REMOVE_DOCUMENT:
      return {
        ...state,
        requiredDocuments: state.requiredDocuments.filter(
          (doc) => doc.documentId !== action.payload
        ),
      };
    case RESET_TEMPLATE_FORM_STATE:
      return {
        ...deepCopy(initialState),
      };
    case SET_TEMPLATE_STATE_FROM_PAYLOAD:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};

const useTemplateForm = () => {
  const [templateState, dispatch] = useReducer(
    templateFormReducer,
    deepCopy(initialState)
  );

  const onChange = (type, payload) => {
    dispatch({ type, payload });
  };

  return { templateState, onChange };
};

export default useTemplateForm;

// Helper functions
/**
 * Generates an empty required documents template with a unique document ID.
 *
 * @returns {object} An object representing an empty required document template.
 *                   It includes properties such as 'documentId', 'documentName', 'documentFile', and 'documentFileName'.
 */
export function getEmptyRequiredDocuments() {
  return {
    documentId: v4(),
    documentName: "",
    documentFile: null,
    documentFileName: "",
  };
}
